import { render, staticRenderFns } from "./dataManagementCenter.vue?vue&type=template&id=114a03da&scoped=true"
import script from "./dataManagementCenter.vue?vue&type=script&lang=js"
export * from "./dataManagementCenter.vue?vue&type=script&lang=js"
import style0 from "./dataManagementCenter.vue?vue&type=style&index=0&id=114a03da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114a03da",
  null
  
)

export default component.exports